import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.background.imageUploader};
  border-radius: ${formatViewport(6)};
  display: flex;
  gap: 4%;
  flex-grow: 0;
  flex-shrink: 0;
  padding: ${formatViewport(22)} ${formatViewport(8)};

  .image-wrapper {
    border-radius: ${formatViewport(7.5)};
    flex-shrink: 0;
    height: ${formatViewport(100)};
    overflow: hidden;
    width: ${formatViewport(100)};

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .content {
    align-items: center;
    color: ${({ theme }) => theme.text.primary};
    display: flex;
    flex-direction: row;
    font-size: ${formatViewport(14)};
    gap: 4%;
    justify-content: space-between;
    width: 100%;

    .title-wrapper {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: 2%;

      .title {
        font-size: ${formatViewport(20)};
      }

      .working-hours {
        color: ${({ theme }) => theme.text.secondary};
      }
    }

    .qr-code-wrapper {
      align-items: center;
      background-color: ${({ theme }) => theme.colors.white};
      display: flex;
      flex-shrink: 0;
      height: ${formatViewport(105)};
      justify-content: center;
      overflow: hidden;
      width: ${formatViewport(105)};
    }
  }
`;
